import React from "react";

import { SubContractorBadge } from "../../../SubContractorBadge";
import { TeamEquipmentComponent } from "./styled";

interface TeamEquipmentProps {
  name: string;
  isSubcontractor: boolean;
}

export const TeamEquipment: React.FC<TeamEquipmentProps> = ({ name, isSubcontractor }) => {
  return (
    <TeamEquipmentComponent>
      <span>{name}</span>
      {isSubcontractor && <SubContractorBadge />}
    </TeamEquipmentComponent>
  );
};
